/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _find from 'lodash/find';

class MovieTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`,
      isYoutube: false,
    };
  }

  componentDidMount() {
    const isYoutube = this.isYoutube();

    this.props.movie.id && lh.models.asset.methods.getPosterUrl(this.props.movie, {
      crop: isYoutube && _get(Config, 'youtube.square_vod', false) ? {x: 132, y: 132} : {x: 90, y: 132},
      cache: false
    })
      .then((url) => {
        this.setState({picture: url});
      });
  }

  componentWillReceiveProps(newProps) {

    if (newProps.movie.id !== this.props.movie.id) {
      const isYoutube = this.isYoutube();

      lh.models.asset.methods.getPosterUrl(newProps.movie, {
        crop: isYoutube && _get(Config, 'youtube.square_vod', false) ? {x: 132, y: 132} : {x: 90, y: 132},
        cache: false
      })
        .then((url) => {
          this.setState({picture: url});
        });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return _get(this.props, 'movie.id') !== _get(nextProps, 'movie.id')
      || this.state.picture !== nextState.picture
      || this.props.isSelected !== nextState.isSelected
      || !_isEqual(_get(nextProps, 'movie', null), _get(this.props, 'movie', null));
  }

  isYoutube = (props = this.props) => {
    let youtubeResource = _find(_get(props.movie, 'resources', []), (resource) => {

      return resource.type === 'stream' && resource.stream_type.indexOf('youtube') !== -1;
    });

    this.setState({
      isYoutube: !!youtubeResource
    });

    return !!youtubeResource;
  }

  render() {

    let movieTileClass = ClassNames({
      'col-last': this.props['col'] === 8,
      'movie block-1 bg-black radius showcase-row-movie-block': true
    });

    let lock = '';
    if (!this.props.movie.is_purchased && !this.props.movie.is_available && !this.props.movie.is_free) {

      lock = <div className="lock">
        <i className="ic ic-lock ic-14px"></i>
      </div>;
    }

    let love = '';
    if (this.props.movie.is_favorite) {
      love = <div className="love">
        <i className="ic ic-fav-in-fill ic-14px"></i>
      </div>;
    }

    return (
      <div className={movieTileClass} onClick={this.props.onMovieSelect.bind(this, this.props.movie, this.props.row, this.props.col)}>
        <a className="movie-link profile-show col hover">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-14px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}
          <div className={this.state.isYoutube && _get(Config, 'youtube.square_vod', false) ? 'channel-poster' : 'movie-poster'}>
            <img src={this.state.picture} alt={this.props.movie.title} className={this.state.isYoutube && _get(Config, 'youtube.square_vod', false) ? 'ico-channel-profile' : ''}/>
          </div>
          {lock}
          {love}
        </a>
      </div>
    );
  }
}

MovieTile.propTypes = {
  movie: PropTypes.object.isRequired,
  onMovieSelect: PropTypes.func.isRequired
};

export default MovieTile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/Movie/movie-tile.js